import { render, staticRenderFns } from "./MateriaCorrelativas.vue?vue&type=template&id=3078a70c&scoped=true&"
import script from "./MateriaCorrelativas.vue?vue&type=script&lang=js&"
export * from "./MateriaCorrelativas.vue?vue&type=script&lang=js&"
import style0 from "./MateriaCorrelativas.vue?vue&type=style&index=0&id=3078a70c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3078a70c",
  null
  
)

export default component.exports